import React, { Component } from "react";
import firebase from '../Fireb';
import '../../App.css';
import { Button, Badge, Card, CardTitle, CardSubtitle, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FaUserGraduate} from "react-icons/fa";

import { ButtonContainer2 } from '../Button'
export default class SearchStudents extends Component {
    constructor(props) {
        super(props);
        this.ref = firebase.firestore().collection('record').where("student", '==', true);
        this.unsubscribe = null;
        this.state = {
          record: [],
          search: '',
          expense: '',
          opened: false,
          balance:0,
          showMyComponent :false
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.updateSearch = this.updateSearch.bind(this);
      
      }
    
    onCollectionUpdate = (querySnapshot) => {
      const record = [];
      querySnapshot.forEach((doc) => {
        const { name, userid, amount,check,status } = doc.data();
        record.push({
          key: doc.id,
          doc, // DocumentSnapshot
          name,
          userid,
          amount,
          check,
          status
        });
      });
      this.setState({
        record
     });
    }
    
    componentDidMount() {
      this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);
    }
    onSubmit(event){
    
      const { opened ,showMyComponent} = this.state;
      
      this.setState({
        opened: !opened,
        showMyComponent: !showMyComponent
      })     ;
      event.preventDefault();
    }
    updateSearch(event) {
      event.preventDefault();
      this.setState({search: event.target.value.substr(0,20)});
    }
    
    render() {
      
      const { opened } = this.state;
      
      const {  cartTotal} = this.props.value;
   
      let filteredRecords = this.state.record.filter(
        (record) => {
          
    
            
    
            if (opened)   {
              return record.userid.indexOf(this.state.search) !== -1;}
              
         
          
         
          else {
            return null}
    
          })
      return (
        <div className="dashboard container">
        <div className="row">
          <div className="col s12 m6">
           
          </div>
    
    
    
    
    
    
          <div className="col s12 m5 offset-m1">
          
                
              <form onSubmit={this.onSubmit}>
              <input id='search' class="form-control mr-sm-2" type="password" placeholder="Search" aria-label="Search" value={this.state.search}
                  onChange={this.updateSearch}
                /> 
                    <ButtonContainer2 disabled={this.state.search <= 9}>

                    <Badge  hidden color="info" pill ><button class="btn btn-info" type="submit" >Search Student</button></Badge>
                    Search Student
                    </ButtonContainer2>
                 </form>
                
                </div>
                <div style={this.state.showMyComponent ? {} : { display: 'none', hidden: true}}>
                <Card>
                  <CardBody>
                    {filteredRecords.map(record =>
                    <tr>
                    <FaUserGraduate fontSize="xx-large"/>
                  
                    <CardTitle ><h6>Student Name </h6>{record.name}</CardTitle>
                    
                   
                    <CardSubtitle>
                    { record.check === true? 
                         <h6>Student Balance : <h4>{record.amount}<text style={{fontSize:12,color:'#2b942d',fontWeight:'bold'}}>Rs.</text></h4> </h6>
                         
                        :
                        <h6>Card status :<h4> <Badge color="danger">{record.status}</Badge></h4></h6>
                      }
                   
                                       
                    
                      </CardSubtitle>
              
                     

                      { (record.check===true )&&(cartTotal<=record.amount)?
                         <Badge fontSize="xx-large"  color="success" pill><Link style={{color:'#f4f4f4'}} to={`/checkout/${record.key}`}>Proceed to Pay</Link></Badge>
                        
                        :
                       console.log()
                      }
                       { (record.check===true )&&(cartTotal>record.amount)?
                         <Badge fontSize="xx-large"  color="warning" style={{color:'#1e1e1e'}} >Insufficeint Balance</Badge>
                        
                        :
                       console.log()
                      }
            
                    
    
                    </tr>
                  )}
                </CardBody>
                
                </Card>
                
              </div>
          </div>
        </div>
    
    
    
    
    
        
      );
    }

  } 